module.exports = __webpack_public_path__ + "img/76276.54997efd.svg";